import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { revealDelay } from '@/lib/motion'

interface SectionHeadingProps {
    label: string
    title: ReactNode
    intro?: ReactNode
    as?: 'h1' | 'h2'
    className?: string
    titleClassName?: string
    id?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({ label, title, intro, as = 'h2', className, titleClassName, id }) => {
    const Title = as

    return (
        <div className={cn('max-w-3xl', className)}>
            <p className='label-caps text-crust-soft' data-reveal='up'>
                {label}
            </p>

            <Title
                id={id}
                className={cn('mt-4 font-heading text-[2.5rem] leading-[1.25] font-normal tracking-[-0.01em] sm:text-5xl lg:text-[3.75rem]', titleClassName)}
                data-reveal='up'
                style={revealDelay(80)}
            >
                {title}
            </Title>

            {intro && (
                <div className='mt-5 max-w-xl text-base leading-relaxed text-crust-soft sm:text-[1.0625rem]' data-reveal='up' style={revealDelay(160)}>
                    {intro}
                </div>
            )}
        </div>
    )
}
